import {SupportedLocales} from '@gl/types/locale.js';

export const insightsLang = {
  [SupportedLocales.EN]: {
    shareResults: {
      modal: {
        title: 'Share Results',
        recipients: {
          label: 'Email Addresses',
          placeholder: 'Enter email addresses...',
        },
        format: {
          label: 'Format',
        },
        notifications: {
          noAudienceId: 'Something went wrong. Please reload and try again.',
        },
      },
    },
  },
  [SupportedLocales.ES]: {
    shareResults: {
      modal: {
        title: 'Compartir Resultados',
        recipients: {
          label: 'Direcciones de correo electrónico',
          placeholder: 'Ingrese direcciones de correo electrónico...',
        },
        format: {
          label: 'Formato',
        },
        notifications: {
          noAudienceId:
            'Algo salió mal. Por favor, recarga y vuelve a intentarlo.',
        },
      },
    },
  },
};
